import React, { memo, useContext, useMemo } from 'react';
import { createUseStyles, Button } from '@Sage/hoi-poi-ui';
import { CopilotContext } from 'shards/Copilot/Context';

import styles from './styles';

const useStyles = createUseStyles(styles);

const Actions = ({ actions, finished }) => {
    const { featureMethods } = useContext(CopilotContext);
    const classes = useStyles();

    const renderActions = useMemo(() => {
        if (!actions?.length) return null;
        return actions
            .map((action, index) => {
                const { type, params } = action;
                const method = featureMethods.ssm?.[type];

                if (!method) return null;

                const buttonProps = {
                    onClick: () => method.action(params),
                    children: method.getCta ? method.getCta(params) : method.cta,
                    type: 'primary',
                    size: 'small',
                };

                return <Button key={`action-${index}`} {...buttonProps} />;
            })
            .filter(Boolean);
    }, [actions, featureMethods.ssm]);

    if (!renderActions || !finished) return null;

    return <div className={classes.root}>{renderActions}</div>;
};

export default memo(Actions);
